export enum SettingsTopicsDataEventObjectsEnum {
  TOPIC = 'topic',
  TOPIC_MERGE = 'topic_merge',
  TOPIC_DELETE = 'topic_delete',
  TOPIC_EDIT = 'topic_edit',
  TOPIC_CONVERSATION = 'topic_conversation',
  TOPIC_RULE = 'topic_rule',
  TOPIC_CREATE_RULE = 'topic_create_rule',
  TOPIC_ANALYTICS = 'topic_analytics',
  TOPIC_VIEW_IN_INBOX = 'topic_view_in_inbox',
  TOPICS_DISCOVERY_BANNER = 'topics_discovery_banner',
  TOPICS_NOT_ENOUGH_CONVERSATION_BANNER = 'topics_not_enough_conversation_banner',
}
